export const CONTRACTING_PDF = 'CONTRACTING_PDF';
